var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7443 0.261068C16.6885 1.4031 15.9653 4.70424 10.5152 10.1544L10.1487 13.4522L6.85092 16.75L7.21736 13.4522L3.55317 9.78801L0.255371 10.1544L3.55317 6.85666L6.85092 6.49021C12.3011 1.04005 15.4191 0.13362 16.7443 0.261068ZM2.63712 14.3683L3.91957 10.8873L6.11811 13.0858L2.63712 14.3683ZM13.813 3.19242L12.968 2.68547L11.6237 3.63772L12.7137 4.29171L13.3435 5.3414L14.2788 3.96894L13.813 3.19242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.6d6016147a9235520f5bf2888fe6e779.svg";
export { ForwardRef as ReactComponent };